export default "__VITE_ASSET__Czn4smAg__"